"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var UISliderTickMark = function UISliderTickMark(_ref) {
  var className = _ref.className,
      currentSliderValue = _ref.currentSliderValue,
      value = _ref.value,
      min = _ref.min;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(className, 'private-slider__tickmark', {
      'private-slider__tickmark--left': value <= currentSliderValue,
      'private-slider__tickmark--filled': min <= value && value <= currentSliderValue
    })
  });
};

UISliderTickMark.propTypes = {
  currentSliderValue: _propTypes.default.number,
  value: _propTypes.default.number,
  min: _propTypes.default.number
};
UISliderTickMark.displayName = 'UISliderTickMark';
var _default = UISliderTickMark;
exports.default = _default;
module.exports = exports.default;